import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Select } from "antd";
import React from "react";
import { $t } from "~/i18n.js";

/**
 * DateListPicker — a form-compatible date selector with prev/next navigation.
 *
 * Props:
 *   value       : any               — the currently selected option value
 *   onChange    : (value) => void   — called when a new value is selected
 *   options     : { value, label }[] — list of selectable options
 *   placeholder : string            — select placeholder text (optional)
 *   style       : object            — extra style applied to the wrapper div
 */
export const DateListPicker = ({
  value,
  onChange,
  options = [],
  placeholder,
  style,
}) => {
  const values = options.map((o) => o.value);
  const currentIdx = value != null ? values.indexOf(value) : -1;

  const handlePrev = () => {
    if (currentIdx <= 0) return;
    onChange(values[currentIdx - 1]);
  };

  const handleNext = () => {
    if (currentIdx < 0 && values.length > 0) {
      onChange(values[0]);
      return;
    }
    if (currentIdx >= values.length - 1) return;
    onChange(values[currentIdx + 1]);
  };

  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center", ...style }}>
      <Button
        shape="circle"
        icon={<LeftOutlined />}
        disabled={currentIdx <= 0}
        onClick={handlePrev}
      />
      <Select
        style={{ flex: 1 }}
        placeholder={placeholder ?? $t("Selecteer een datum")}
        options={options}
        value={value ?? undefined}
        allowClear
        onChange={(v) => onChange(v ?? null)}
      />
      <Button
        shape="circle"
        icon={<RightOutlined />}
        disabled={currentIdx >= values.length - 1 && (currentIdx >= 0 || values.length === 0)}
        onClick={handleNext}
      />
    </div>
  );
};
